export default "__VITE_ASSET__kX0XIWPo__"